import { useTranslation } from '@mc/i18n'
import { PEN_5038_V1_MEGA_CONTENT_PICKER_I18N_NAMESPACE } from '../i18n'
import { usePen5038Experiment } from './usePen5038Experiment'

interface UseJustLaunchedTagProps {
  isJustLaunched: boolean
  originalTag: string
}

export const useJustLaunchedTag = ({
  isJustLaunched,
  originalTag,
}: UseJustLaunchedTagProps) => {
  const { isEnabled } = usePen5038Experiment()
  const { t } = useTranslation(PEN_5038_V1_MEGA_CONTENT_PICKER_I18N_NAMESPACE)

  if (isEnabled && isJustLaunched) {
    return t('trending.justLaunched')
  }

  return originalTag
}
